"use strict";exports.__esModule = true;exports.default = void 0;var _default = {
  handleCollapse(_ref) {var originalEvent = _ref.originalEvent;
    if (this._expander.expanded) {
      this._expander.expanded = false;
      this.emit('collapse', { originalEvent });
    }
  },

  handleExpand(_ref2) {var originalEvent = _ref2.originalEvent;
    if (!this._expander.expanded) {
      this._expander.expanded = true;
      this.emit('expand', { originalEvent });
    }
  },

  onMount() {
    this._expander = this.getComponent('base')._expander;
    this._expander.expanded = true;
  } };exports.default = _default;module.exports = exports.default;